<template>
  <div class="P-Abs W-100 H-100 Inset0 D-Flex" style="z-index: 40;">
    <div class="BG1 P-Abs W-100 H-100 Inset0 O-50" style="border-radius: var(--rad2);"></div>
    <div class="M-Auto">
      <CookiesLoading></CookiesLoading>
    </div>
  </div>
</template>
